import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Glyphicon } from 'react-bootstrap';
import './InfoModal.css';

const InfoModal = ({ title, isOpen, onClose, children }) => {
  const handleClose = onClose || (() => {});

  return (
    <Modal
      className="tvt-modal-info__modal"
      show={isOpen}
      onHide={handleClose}
      backdrop
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Glyphicon
          className="tvt-modal-info__modal-close-btn"
          onClick={handleClose}
          glyph="remove"
        />
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <Button onClick={handleClose}>Ok</Button>
      </Modal.Footer>
    </Modal>
  );
};

InfoModal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default InfoModal;
